// src/components/page-content-v4/contexts/PageListContext.tsx
import React, { createContext, useContext } from 'react';
import { useParams } from 'react-router-dom';
import { usePageList } from '../hooks/usePageList';
import { PaginationParams, Template, PageData } from '@/components/page-content-v4/types';

interface PageListContextProps {
  templateId: string | undefined;
  template: Template | null;
  pages: PageData[];
  isLoading: boolean;
  error: Error | null;
  pagination: PaginationParams;
  setPagination: (pagination: PaginationParams) => void;
  totalItems: number;
  refreshPages: () => void;
}

const PageListContext = createContext<PageListContextProps | undefined>(undefined);

export const PageListProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { templateId } = useParams<{ templateId: string }>();
  const {
    template,
    pages,
    isLoading,
    error,
    pagination,
    setPagination,
    totalItems,
    refreshPages,
  } = usePageList(templateId);

  const contextValue = {
    templateId,
    template,
    pages,
    isLoading,
    error,
    pagination,
    setPagination,
    totalItems,
    refreshPages,
  };

  return <PageListContext.Provider value={contextValue}>{children}</PageListContext.Provider>;
};

export const usePageListContext = () => {
  const context = useContext(PageListContext);
  if (context === undefined) {
    throw new Error('usePageListContext must be used within a PageListProvider');
  }
  return context;
};
